import React from "react";
import "./DocsHeader.css";

function DocsHeader() {
  return (
    <div>
      <div className="docsheader">
        <div>
          <h3>Build rapidly fast website with</h3>
          <h1>🧿EFFORTLESS UI</h1>
        </div>
        <img src='https://raw.githubusercontent.com/rohan9896/Testing-for-CSS-component-library/eb0794cf9ac251e23c16cd6c6fb79c1fd15b72f8/icons/bannerInsideBanner.svg' alt='bannerInsideBanner' />
      </div>
    </div>
  );
}

export default DocsHeader;
